/* Material */
import Typo from '@mui/material/Typography'
import useStyles from './styles'

interface Props {
  betreff: string
  email: string
  message: string
}

const Gesendet: React.FC<Props> = ({ betreff, email, message }) => {
  const classes = useStyles()

  return <div className={classes.gesendet}>

    <Typo variant="h5">
      Danke für deine Nachricht!
    </Typo>

    <Typo variant="body1">
      Wir haben Ihre Nachricht erhalten und werden uns schnellstmöglich bei Ihnen melden.
    </Typo>

    <hr />

    <Typo variant="h6">
      Details zu Ihrer Nachricht:
    </Typo>

    <Typo variant="body1">
      Betreff: {betreff}
    </Typo>
    <Typo variant="body1">
      Email: {email}
    </Typo>

    <Typo variant="body1">
      <pre>{message}</pre>
    </Typo>

  </div>
}
  
export default Gesendet
